define('customerInternalCommentsListView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'marionette',
  'customerInternalCommentsListCommentView',
  'customerInternalCommentsListView',
  'settings',
  'commentsTags',
  'entities/customers/customers_comments'
], function (
  App,
  Module,
  Backbone,
  _,
  Marionette,
  CommentView,
  EditView,
  Settings,
  Tags
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    childView: CommentView,
    className: 'list-view',

    childViewOptions: function() {
      return {
        secId: this.options.secId,
        listView: this,
        pin: true
      };
    },

    childEvents: {
      'delete': 'onDelete',
      'removeTag': 'onRemoveTag',
      'pin': 'onPin'
    },  
    
    initialize: function() {
      this.collection = App.request('customercomments:get-collection');      
      this.allCollection = App.request('customercomments:get-collection');

      if(this.options.tagsView) { 
        this.options.tagsView.on('change', _.bind(function() {
          this.fetch();
        }, this));
      }
    },

    onShow: function() {      
      this.fetch();      
    },

    onRender: function() {
      if(Settings.configValue('advancedMode') === true) {
        var items = {};
        _.each(Tags.get(), function(tag) {
          if(tag.contextMenu) {
            items[tag.id] = {
              name: tag.name
            };
          }
        }, this);

        this.$el.contextMenu({
          selector: '.comment-view',
          className: 'comment-context-menu',
          build: _.bind(function () {
            return {
              callback: _.bind(function (tag, options) {
                var model = this.collection.get(options.$trigger.data('cid'));              
                model.addTag(tag);    
                model.save(this.options.secId).done(_.bind(function() {
                  this.fetch();
                }, this)).fail(_.bind(function() {
                  this.fetch();
                }, this));
              }, this),
              items: items
            };
          }, this)
        });
      }
    },

    fetch: function() {        
      this.allCollection.fetch(this.options.secId).done(_.bind(function() {   
        if (this.isDestroyed)
          return;
         
        var models = this.allCollection.models;        
        //-----------------
        if(this.options.tagsView) { 
          _.each(this.options.tagsView.tags, function(tag) {
            var visible = false;
            _.each(models, function(model) {
              if(model.get('tags') && model.get('tags').includes(tag.id)) 
                visible = true;               
            }, this);
            tag.visible = visible;
          }, this);
          
          this.options.tagsView.fetch();
          
          models = _.filter(this.allCollection.models, function(model) {
            var selectedTag = this.options.tagsView.getSelected();
            if(selectedTag) {               
              if(selectedTag.get('id') === '') {
                var archived = model.get('tags') && model.get('tags').includes('archived');
                if(!archived)
                  return true;
                else
                  return false;
              }          
              
              if(model.get('tags') && model.get('tags').includes(selectedTag.get('id')))
                return true;

              return false;
            } else 
              return true;
            
          }, this);
        }       

        this.collection.set(models);        
        this.collection.sort();

         if(this.collection.models.length > 0)
          this.options.parentView.onOpen();
        this.options.parentView.ui.counter.html(this.collection.length);

      }, this));
    },

    onDelete: function(view) {     
      view.model.destroy().done(_.bind(function () {
        this.fetch();
      }, this)).fail(_.bind(function() {
        this.fetch();
      }, this));
    },

    onPin: function(view) {     
      view.model.set('pin', !view.model.get('pin'));
      view.model.unset('content');
      view.model.unset('modDate');
      view.model.unset('userpid');

      view.model.save(this.options.secId).done(_.bind(function() {
        this.fetch();
      }, this));
    },

    onRemoveTag: function(view, key) {     
      if (this.options.removeTag)
        this.options.removeTag(view.model, key);
    }
  });
});
